export const mapStyles = [
    {
        'name': 'Standaard',
        'slug': 'classic',
    },
    {
        'name': 'Zwart',
        'slug': 'impact-black',
    },
    {
        'name': 'Mono',
        'slug': 'mono',
    },
    {
        'name': 'Antiek',
        'slug': 'antique',
    },
    {
        'name': 'Lo-Fi',
        'slug': 'lo-fi',
    },
    {
        'name': 'Cold Horizon',
        'slug': 'cold-horizon',
    },
    {
        'name': 'metropolis',
        'slug': 'metropolis',
    },
    {
        'name': 'empire-green',
        'slug': 'empire-green',
    },
    {
        'name': 'coral-sunset',
        'slug': 'coral-sunset',
    },
    {
        'name': 'Baby Blue',
        'slug': 'baby-blue',
    },
    {
        'name': 'Pink Cove',
        'slug': 'pink-cove',
    },
    {
        'name': 'Minimal',
        'slug': 'minimal',
    },
    {
        'name': 'Urban',
        'slug': 'urban',
    },
    {
        'name': "Black Lantern",
        'slug': 'black-lantern',
    },
];